<div fxLayout="column" fxFlexFill style="position: relative">
  <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
    <mat-spinner></mat-spinner>
  </div>
  <div fxFlex="auto" fxFlexFill class="table-container">
    <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table fax-table responsive"
               matSort matSortActive="faxDate" matSortDirection="desc" matSortDisableClear>
      <ng-container matColumnDef="faxDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header="faxDate">Date</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Date:</span>
          <span>
            {{row.faxDate | dateTime: 'M/dd/yyyy hh:mm a'}}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef mat-sort-header="type">Type</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Type:</span>
          <span [ngClass]="{
                    'badge-outgoing': row.type == 'outgoing',
                    'badge-incoming': row.type == 'incoming'
                    }">
            <i class="material-icons">{{row.type == 'outgoing' ? 'call_made' : 'call_received'}}</i>
            {{row.type}}
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tnTo">
        <mat-header-cell *matHeaderCellDef mat-sort-header="tnTo">To</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">To:</span>
          <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <span>{{row.tnTo | phoneNumber}}</span>
            <button mat-icon-button class="button-32"
                    matTooltip="Add to contacts"
                    *ngIf="hasContactsModule && hasContactsEditRight && !row.contactTo"
                    (click)="addNewContact($event, row.tnTo)">
              <mat-icon>person_add</mat-icon>
            </button>
            <span *ngIf="row.contactTo" style="white-space: nowrap"> – {{row.contactTo.name}}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="tnFrom">
        <mat-header-cell *matHeaderCellDef mat-sort-header="tnFrom">From</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">From:</span>
          <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <span>{{row.tnFrom | phoneNumber}}</span>
            <button mat-icon-button class="button-32"
                    matTooltip="Add to contacts"
                    *ngIf="hasContactsModule && hasContactsEditRight && !row.contactFrom"
                    (click)="addNewContact($event, row.tnFrom)">
              <mat-icon>person_add</mat-icon>
            </button>
            <span *ngIf="row.contactFrom" style="white-space: nowrap"> – {{row.contactFrom.name}}</span>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="createdBy">
        <mat-header-cell *matHeaderCellDef mat-sort-header="createdBy">Sent By</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Sent By:</span>
          {{ row.type == 'outgoing' ? row.createdBy : '' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef mat-sort-header="status">Status</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Status:</span>
          {{ row.status }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="pages">
        <mat-header-cell *matHeaderCellDef mat-sort-header="pages">Pages</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Pages:</span>
          {{ row.pages }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="internalNotes">
        <mat-header-cell *matHeaderCellDef mat-sort-header="internalNotes">Notes</mat-header-cell>
        <mat-cell *matCellDef="let row">
          <span class="mobile-label">Notes:</span>
          <span fxLayout="row" fxLayoutAlign="start center" >
            <span>
              {{row.internalNotes}}
            </span>
            <button mat-icon-button class="button-32" *ngIf="hasEditAccess"
                    (click)="editInternalNotes(row)"
                    matTooltip="Edit Internal Notes">
              <mat-icon>edit</mat-icon>
            </button>
          </span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let row" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <button mat-icon-button class="button-32" matTooltip="Retry Fax"
                  *ngIf="row.orgFilename1 && row.status?.toLowerCase().indexOf('failed') > -1"
                  (click)="onOpenRetryDialog($event, row)">
            <mat-icon>refresh</mat-icon>
          </button>
          <div *ngIf="row.hasFile && row.fileSize != 32" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
            <button mat-icon-button class="button-32" matTooltip="View" (click)="previewPdf($event, row)">
              <mat-icon>visibility</mat-icon>
            </button>
            <a mat-icon-button class="button-32" matTooltip="Download" color="primary" *ngIf="userRights.downloadFax"
               target="_blank" href="/api/fax/download-fax/{{row.callerId}}/{{row.faxId}}">
              <mat-icon>download</mat-icon>
            </a>
            <button mat-icon-button class="button-32" color="warn" matTooltip="Delete" *ngIf="userRights.deleteFax"
                    (click)="onDeleteFaxConfirm($event, row)">
              <mat-icon>delete</mat-icon>
            </button>
            <button mat-icon-button class="button-32" color="primary" matTooltip="Mark As Unread"
                    *ngIf="row.type == 'incoming'" (click)="onMarkAsUnread($event, row)">
              <mat-icon>mark_chat_unread</mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row" [class.unread]="row.unread"
               (click)="markRowAsUnread(row)"></mat-row>
    </mat-table>
  </div>
  <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
</div>
